import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

export type CommandOpenTabsCopy = {
  heading: string;
  newTab: string;
  current: string;
  contentMatch: string;
  threadAssets: string;
  dashboard: string;
};

const ENGLISH: CommandOpenTabsCopy = {
  heading: 'Open tabs',
  newTab: 'New tab',
  current: 'Current',
  contentMatch: 'File content',
  threadAssets: 'Thread assets',
  dashboard: 'Dashboard',
};

const COPY: Record<SupportedLocale, CommandOpenTabsCopy> = {
  en: ENGLISH,
  'pt-BR': {
    heading: 'Abra as abas',
    newTab: 'P\u00E1gina nova',
    current: 'Atual',
    contentMatch: 'Conte\u00FAdo do arquivo',
    threadAssets: 'Activos de thread',
    dashboard: 'Painel',
  },
  ar: {
    ...ENGLISH,
    heading: 'علامات التبويب المفتوحة',
    newTab: 'علامة تبويب جديدة',
    current: 'الحالية',
    contentMatch: 'محتوى الملف',
    threadAssets: 'أصول المحادثة',
    dashboard: 'لوحة المعلومات',
  },
  es: {
    ...ENGLISH,
    heading: 'Pestañas abiertas',
    newTab: 'Nueva pestaña',
    current: 'Actual',
    contentMatch: 'Contenido del archivo',
    threadAssets: 'Recursos del hilo',
    dashboard: 'Panel',
  },
  fr: {
    ...ENGLISH,
    heading: 'Onglets ouverts',
    newTab: 'Nouvel onglet',
    current: 'Actuel',
    contentMatch: 'Contenu du fichier',
    threadAssets: 'Ressources de la discussion',
    dashboard: 'Tableau de bord',
  },
  it: {
    ...ENGLISH,
    heading: 'Schede aperte',
    newTab: 'Nuova scheda',
    current: 'Attuale',
    contentMatch: 'Contenuto del file',
    threadAssets: 'Risorse della chat',
    dashboard: 'Dashboard',
  },
  ko: {
    ...ENGLISH,
    heading: '열린 탭',
    newTab: '새 탭',
    current: '현재',
    contentMatch: '파일 내용',
    threadAssets: '스레드 에셋',
    dashboard: '대시보드',
  },
  de: {
    ...ENGLISH,
    heading: 'Geöffnete Tabs',
    newTab: 'Neuer Tab',
    current: 'Aktuell',
    contentMatch: 'Dateiinhalt',
    threadAssets: 'Thread-Assets',
    dashboard: 'Dashboard',
  },
  ja: {
    ...ENGLISH,
    heading: '開いているタブ',
    newTab: '新しいタブ',
    current: '現在',
    contentMatch: 'ファイル内容',
    threadAssets: 'スレッドのアセット',
    dashboard: 'ダッシュボード',
  },
  hi: {
    ...ENGLISH,
    heading: 'खुले टैब',
    newTab: 'नया टैब',
    current: 'वर्तमान',
    contentMatch: 'फ़ाइल सामग्री',
    threadAssets: 'थ्रेड एसेट',
    dashboard: 'डैशबोर्ड',
  },
  ru: {
    ...ENGLISH,
    heading: 'Открытые вкладки',
    newTab: 'Новая вкладка',
    current: 'Текущая',
    contentMatch: 'Содержимое файла',
    threadAssets: 'Материалы обсуждения',
    dashboard: 'Панель управления',
  },
  zh: {
    ...ENGLISH,
    heading: '打开的标签页',
    newTab: '新建标签页',
    current: '当前',
    contentMatch: '文件内容',
    threadAssets: '线程资源',
    dashboard: '仪表板',
  },
  'zh-TW': {
    ...ENGLISH,
    heading: '開啟的分頁',
    newTab: '新增分頁',
    current: '目前',
    contentMatch: '檔案內容',
    threadAssets: '對話串資源',
    dashboard: '儀表板',
  },
  vi: {
    ...ENGLISH,
    heading: 'Tab đang mở',
    newTab: 'Tab mới',
    current: 'Hiện tại',
    contentMatch: 'Nội dung tệp',
    threadAssets: 'Tài nguyên cuộc trò chuyện',
    dashboard: 'Bảng điều khiển',
  },
  id: {
    ...ENGLISH,
    heading: 'Tab terbuka',
    newTab: 'Tab baru',
    current: 'Saat ini',
    contentMatch: 'Isi file',
    threadAssets: 'Aset percakapan',
    dashboard: 'Dasbor',
  },
};

export function getCommandOpenTabsCopy(
  locale: string | null | undefined
): CommandOpenTabsCopy {
  return COPY[normalizeLocale(locale)];
}
